/**
 * ══════════════════════════════════════════════════════════════════════════
 * ÖZ-PUANLAMA KAPISI — KLİP YÜZEYLERİ İÇİN TEK KARAR NOKTASI
 *
 * `firestore.rules:3147/:3165` öz-puanlamayı YASAKLAR
 * (`get(.../content/$(contentId)).data.authorId != request.auth.uid`).
 * Kural DOĞRU. Kusur arayüzdeydi: klip yüzeyleri tetiği canlı gösteriyor,
 * kullanıcı 1–5 seçiyor, sunucu reddediyor ve ekrana **"Puan kaydedilemedi"**
 * çıkıyordu — yani ürün, olmayacak bir eylemi teklif edip sonra kendi
 * kuralını arıza gibi gösteriyordu (GÖZ raporu §2 · A1).
 *
 * ── NEDEN AYRI DOSYA ─────────────────────────────────────────────────────
 * Aynı karar BEŞ klip yüzeyinde veriliyor (`ClipInFeed` · `FloatingActions`
 * · `EngagementRailV3` · `MyClips` · `ClipsDesktop`). Ölçüt beş yere elle
 * yazılırsa altıncı yüzey yarın yine unutulur — #937'de tam olarak bu oldu:
 * kilit üç GÖNDERİ yüzeyine kondu, klip tarafı kapsam dışı kaldı.
 *
 * ── İKİNCİ OTORİTE ÜRETMEZ ───────────────────────────────────────────────
 * "Klip benim mi" ölçütü ZATEN tek yerde yazılı: `kendiKlibiMi`
 * (`myclipsv3/engagement/ilgilenmiyorumAkisi.ts`; `useClipEngagement`in
 * `isOwnClip`i de oradan gelir). Burada o ölçüt YENİDEN YAZILMAZ, çağrılır.
 * O dosyanın SIFIR import'u var → bu yön yaprak, döngü yok.
 * ══════════════════════════════════════════════════════════════════════════
 */

import { kendiKlibiMi } from "../myclipsv3/engagement/ilgilenmiyorumAkisi";

/**
 * Devre dışı tetiğin SEBEBİ — tek metin.
 *
 * Gönderi emsalinin ("Kendi gönderine puan veremezsin", #931) klip
 * karşılığı. Aynı cümle hem `aria-label` hem `title` olur; WCAG 2.5.3
 * (Label in Name) açısından güvenli, çünkü tetik ikon-tabanlıdır ve
 * görünür bir metin etiketi TAŞIMAZ → çelişecek bir görünür ad yok.
 */
export const OZ_PUANLAMA_SEBEBI_KLIP = "Kendi klibine puan veremezsin";

/**
 * Bu izleyici bu klibe puan VEREMEZ mi? (`true` → tetik `disabled`.)
 *
 * ⚠️ Anonim izleyicide `false` döner — kapı yalnız ÖZ-puanlamayı kapatır.
 * Giriş yapmamış kullanıcıya "giriş yap" demek yüzeylerin kendi işidir
 * (`niSatiriGorunur`in aynı gerekçesi: gizlemek NEDEN'i anlatmaz).
 */
export function ozPuanlamaKapali(
  izleyiciUid: string | null | undefined,
  yazarUid: string | null | undefined,
): boolean {
  return kendiKlibiMi(izleyiciUid, yazarUid);
}
